import get from 'lodash/get'
import { TechpackRowItem } from '../techpacks.model'
import { GetSharedFolderByIdQuery } from '@/graphql/generated/types'

/**
 * converts graphQL API response into UI state object
 * @param folderDetails data returned from graphQL response
 */
export default function folderDetailsDataMapper(
  folderDetails: GetSharedFolderByIdQuery['getSharedFolderById']
): Array<TechpackRowItem> {
  return (
    folderDetails?.techpacks?.map(techpack => {
      return {
        _id: get(techpack, 'techpack._id', ''),
        folderName: get(folderDetails, 'name', ''),
        folderId: get(folderDetails, '_id', ''),
        name: get(techpack, 'techpack.name', 'N/A'),
        productName: get(techpack, 'techpack.product.name', 'N/A'),
        productCode: get(techpack, 'techpack.product.code', 'N/A'),
        details: {
          attachmentCount: techpack?.techpack?.attachments?.length || 0
        },
        addedAt: get(techpack, 'createdAt', 'N/A')
      }
    }) || []
  )
}
